"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../utils");

var _utils2 = require("../utils");

var _TabSwitcherContext = require("./TabSwitcherContext");

var _core = require("@emotion/core");

var _excluded = ["children", "value", "tabGroup"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TabPanelWithoutDocs = function TabPanelWithoutDocs(_ref) {
  var children = _ref.children,
      value = _ref.value,
      tabGroupFromProps = _ref.tabGroup,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_TabSwitcherContext.TabSwitcherContext),
      tabGroupFromContext = _useContext.tabGroup;

  var tabGroup = tabGroupFromProps || tabGroupFromContext;

  if (!tabGroup && !(0, _utils.envIsProduction)()) {
    console.warn('Tabs: When <TabPanel> is used outside a <TabSwitcher>, the `tabGroup` prop must be specified. Check the tab panel with data-test-flagged="tab-panel-outside-switcher".');
    forwardedProps['data-test-flagged'] = 'tab-panel-outside-switcher';
  }

  var tabId = (0, _utils2.getTabId)(tabGroup, value);
  var panelId = (0, _utils2.getPanelId)(tabId);
  return (0, _core.jsx)("div", (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
    role: "tabpanel",
    id: panelId,
    "aria-labelledby": tabId
  }), children);
};

var TabPanelWithDocs = (0, _stencilReactDesc.describe)(TabPanelWithoutDocs).description('Container for tab contents.');
TabPanelWithDocs.propTypes = {
  children: _stencilReactDesc.PropTypes.node.description('Content to display in the tab panel.'),
  value: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number]).isRequired.description('Unique identifier for the tab this panel corresponds to.'),
  tabGroup: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number]).description('The identifier for the set of tabs this panel belongs to. The same tabGroup should be passed to the TabBar for these tabs.')
};
var TabPanel = (0, _utils.withTestAttributes)({
  component: 'StencilTabPanel'
})(TabPanelWithDocs);
TabPanel.displayName = 'TabPanel';
var _default = TabPanel;
exports.default = _default;